import ActionBar from './ActionBar'
import * as actDiscount from 'actions/library/discount'
import {connect} from 'react-redux'
import List from './List'
import styles from './Discount.css'
import ConfirmActionModal from 'components/ConfirmActionModal'
import ConfirmDeleteModal from './ConfirmDeleteModal'
import {isDirty} from 'redux-form'
import {browserHistory} from 'react-router'
import {askConfirmAction} from 'actions/confirm-action'
import {push} from 'react-router-redux'

class Discount extends React.Component {
  componentDidMount () {
    const {expired} = this.props
    if (!expired) {
      this.props.dispatch(actDiscount.pageRequest())
      browserHistory.listenBefore((location) => {
        // this is still hacky, don't copy paste this
        if (this.props.isDirtyDiscount && !this.props.nextAction) {
          this.props.dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    return (<div className={styles.wrapper}>
      <ActionBar />
      <List />
      <ConfirmActionModal />
      <ConfirmDeleteModal />
    </div>)
  }
}

Discount.propTypes = {
  dispatch: React.PropTypes.func
}

function mapStateToProps (state) {
  const isDirtyDiscount = isDirty('discount')(state)
  const nextAction = state.confirmAction.nextAction
  const {expired} = state.subscriptionExpired
  return {isDirtyDiscount, nextAction, expired}
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Discount)



// WEBPACK FOOTER //
// ./app/pages/Library/Discount/Discount.js